import { render, staticRenderFns } from "./ECensoDialogTxt.vue?vue&type=template&id=5551b65b"
import script from "./ECensoDialogTxt.vue?vue&type=script&lang=js"
export * from "./ECensoDialogTxt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports